module.exports = __webpack_public_path__ + "static/media/brand-refresh-OrdersDot.07c70605.svg";